import React, { FC, memo } from 'react';
import { useMutation } from 'react-query';
import {
  DeleteTwoTone,
  ExclamationCircleOutlined,
} from '@ant-design/icons/lib';
import { Button, message, Modal } from 'antd';
import { red } from '@ant-design/colors';
import { ButtonProps } from 'antd/lib/button';
import { UsersAPI } from 'api/UsersAPI';
import { Patient } from 'models/patient';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { FormattedMessage } from 'react-intl';
export interface DeletePatientProps
  extends Omit<ButtonProps, 'onClick' | 'loading' | 'href'> {
  patient: Patient;
  onDeleted?: () => void;
}

export const DeletePatientButton: FC<DeletePatientProps> = memo(
  ({ patient, onDeleted, ...buttonProps }) => {
    const [mutate, { isLoading }] = useMutation(UsersAPI.deletePatient);
    const intlMessage = useFormatMessage();

    const confirm = () =>
      Modal.confirm({
        title: intlMessage(
          { id: 'entity.delete.confirmation' },
          {
            name: `${patient.firstName} ${patient.lastName}`,
          }
        ),
        icon: <ExclamationCircleOutlined />,
        okText: intlMessage({ id: 'yes' }),
        cancelText: intlMessage({ id: 'cancel' }),
        okType: 'danger',
        onOk: () =>
          mutate(
            { id: patient.id },
            {
              onSuccess: () => {
                message.success(
                  intlMessage(
                    { id: 'entity.delete.success' },
                    {
                      name: `${patient.firstName} ${patient.lastName}`,
                    }
                  )
                );
                onDeleted && onDeleted();
              },
            }
          ),
      });

    return (
      <Button
        id="button-delete-patient"
        loading={isLoading}
        onClick={() => confirm()}
        icon={<DeleteTwoTone twoToneColor={red.primary} />}
        {...buttonProps}
      >
        <FormattedMessage id="delete" tagName="span" />
      </Button>
    );
  }
);
